import{Slot as l,Slottable as e}from"@radix-ui/react-slot";export{l as Slot,e as Slottable};
//# sourceMappingURL=slot.js.map
